import React from 'react';
import { offer } from '../data/offer';
import { useDeadlineCountdown } from '../hooks/useDeadlineCountdown';
import { OfferCountdown } from './OfferCountdown';
export function UrgencyBanner() {
  const timeLeft = useDeadlineCountdown(offer.closesAt);
  const showSpots = offer.spotsAvailable !== null;
  if (!timeLeft && !showSpots) return null;

  // One copy of the message; rendered twice so the loop is seamless.
  const Message = ({
    hidden = false
  }: {
    hidden?: boolean;
  }) => <div className="flex items-center gap-6 pr-6 shrink-0" aria-hidden={hidden || undefined} data-id="element-218" data-mp="31a36oj4ffd4n">
      {timeLeft && <span className="flex items-center gap-1.5 text-brand-goldLight" data-id="element-219" data-mp="36a7nka98y9ve">
          ⏳ Precio de lanzamiento disponible hasta:
          <OfferCountdown variant="compact" data-id="element-220" data-mp="3b7hj87n8bhro" />
        </span>}
      {timeLeft && showSpots && <span className="text-brand-gold" data-id="element-221" data-mp="1bwpvqb1t6quk">✦</span>}
      {showSpots && <span data-id="element-222" data-mp="1gv9igdo886nz">
          Cupos disponibles a {offer.price}:{' '}
          <strong className="tabular-nums text-brand-goldLight" data-id="element-223" data-mp="27eq0rswtngoc">
            {offer.spotsAvailable}
          </strong>
        </span>}
      <span className="text-brand-gold" data-id="element-224" data-mp="22mygu1868976">✦</span>
      <a href="#oferta" tabIndex={hidden ? -1 : undefined} className="bg-brand-gold text-brand-purpleDark font-bold text-[11px] md:text-xs px-3 py-1 rounded-full hover:bg-brand-goldLight transition-colors duration-150" data-id="element-225" data-mp="22m6m0smeefhy">
        → VER EL MEGAPACK
      </a>
      <span className="text-brand-gold" data-id="element-226" data-mp="2qbhqak2yis0u">✦</span>
    </div>;
  return <div className="sticky top-0 z-50 w-full bg-brand-purpleDark text-white border-b border-brand-gold/30 shadow-md overflow-hidden" data-id="element-227" data-mp="2lfslo2c2ykxo">
      <div className="banner-marquee flex w-max whitespace-nowrap py-2 text-[12px] md:text-sm font-medium" data-id="element-228" data-mp="2gh93md0lxtal">
        <Message data-id="element-229" data-mp="1509c3jm33ihm" />
        <Message hidden data-id="element-230" data-mp="150r4u69jfeks" />
        <Message hidden data-id="element-231" data-mp="1510vzx6bjrs2" />
        <Message hidden data-id="element-232" data-mp="151kbl78hy42x" />
      </div>
    </div>;
}